import { DbHelper } from "@app/shared/model/db-object.model";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface EntityInfoData {
    id: number;
    entity_id: number;
    entityinfo_type_id: number;
    active: boolean;
    description: string;
    data: string;
    version: string;
    previous_id: string;
}

export class EntityInfo {
    static dbTypeName = "info";
    static dbEndpoint = "entityinfo";

    static readonly importMap: ImportMap<EntityInfo, EntityInfoData> = [
        { i: "id", o: "id" },
        { i: "entity_id", o: "entityId" },
        { i: "entityinfo_type_id", o: "entityInfoTypeId" },
        { i: "active", o: "active" },
        { i: "description", o: "description" },
        { i: "data", o: "data" },
        { i: "version", o: "version" },
        { i: "previous_id", o: "previousId" },
    ];

    constructor(
        public readonly entityId: number,
        public entityInfoTypeId: number,
        public description: string,
        public data: { [key: string]: any },
        public type?: EntityInfoType,
        public readonly version?: number,
        public active: boolean = true,
        public readonly previousId?: number,
        public readonly id?: number
    ) {}
}

export class EntityInfoHelper extends DbHelper<EntityInfo, EntityInfoData> {
    static readonly importMap: ImportMap<EntityInfo, EntityInfoData> = [
        { i: "id", o: "id" },
        { i: "entity_id", o: "entityId" },
        { i: "entityinfo_type_id", o: "entityInfoTypeId" },
        { i: "active", o: "active" },
        { i: "description", o: "description" },
        { i: "data", o: "data" },
        { i: "version", o: "version" },
        { i: "previous_id", o: "previousId" },
    ];

    importMap = EntityInfoHelper.importMap;

    static fromDbObject(entity: any): EntityInfo {
        return new EntityInfo(
            entity[EntityInfo.importMap[1].i],
            entity[EntityInfo.importMap[2].i],
            entity[EntityInfo.importMap[4].i],
            JSON.parse(entity[EntityInfo.importMap[5].i]),
            entity["type_name"],
            entity[EntityInfo.importMap[6].i],
            entity[EntityInfo.importMap[3].i],
            entity[EntityInfo.importMap[7].i],
            entity[EntityInfo.importMap[0].i]
        );
    }

    fromDbObject(entity: any): EntityInfo {
        return EntityInfoHelper.fromDbObject(entity);
    }

    toDbObject(obj: EntityInfo): EntityInfoData {
        const entityInfoData = ClassImporterExporter.exportObject(obj, this.importMap);
        entityInfoData.data = JSON.stringify(obj.data);
        return entityInfoData;
    }
}

export interface EntityInfoType {
    id: number;
    name: string;
    key: string;
    description: string;
}

export class EntityInfoTypeHelper {
    static dbTypeName = "";
    static dbTypeNamePlural = "";
    static importMap: ImportMap<EntityInfoType, EntityInfoType> = [];

    static fromDbObject(data: EntityInfoType): EntityInfoType {
        return data;
    }

    static toDbObject(obj: EntityInfoType): EntityInfoType {
        return obj;
    }
}

export enum EntityInfoTypes {
    CentralStation = "alarm-reporting-number",
    CentralStationEmergencyNumber = "two-way-calling-number",
    ServicePlan = "customer-plan-rate",
    HomeBuilders = "home-builders",
    HomeCommunities = "home-communities",
    BuildingType = "building-type",
    municipalities = "municipalities",
}
